/**
 * Build: global4.js
 */

import $ from 'jquery';
import 'what-input';

// Foundation JS relies on a global variable. In ES6, all imports are hoisted
// to the top of the file so if we used `import` to import Foundation,
// it would execute earlier than we have assigned the global variable.
// This is why we have to use CommonJS require() here since it doesn't
// have the hoisting behavior.
// Page layouts preload jQuery slim from a CDN in <head> so inline scripts have
// $ available immediately. That CDN copy is a separate instance from this
// bundle's jquery import, so plugins attached below (like the iframe-resizer
// shim) need window.$ repointed at the bundled copy too, or inline scripts
// keep calling methods on the CDN instance that never got them registered.
window.jQuery = $;
window.$ = $;
require('foundation-sites');
// iframe-resizer v4 is the last MIT-licensed release (no license required), 
// and self-registers both window.iFrameResize()
// and, since jQuery is already global by this point, $.fn.iFrameResize() for
// older embeds using that syntax. Needs require(), not import, for the same
// reason as foundation-sites above: it reads window.jQuery at load time.
require('iframe-resizer');


// If you want to pick and choose which modules to include, comment out the above and uncomment
// the line below
//import './lib/foundation-explicit-pieces';


$(document).foundation();

// Libraries
// ---------
import './lib/foundation-settings';
import './lib/prism';
import './lib/swiper-core';

// Utilities
// ---------



// Components
// ----------

// Navigation
import './components/navigation/top-bar';
import './components/navigation/top-bar-dropdown-menus'; 
import './components/navigation/off-canvas-mobile-menu';
import './components/navigation/off-canvas-main-menu';
import './components/navigation/page-menu';
import './components/navigation/search'; 
// Sticky scroll
import './components/sticky-scroll/sticky-menu-buttons';
import './components/sticky-scroll/scroll-to-top'; 
import './components/sticky-scroll/footer-sticky-bar';
// Animations
import './components/animations/animate-in-view';
import './components/animations/callout-stat';
import './components/animations/logo';
import './components/animations/roll-text';
// Containers
import './components/containers/accordion-panel';
import './components/containers/events-slider';
// Media
import './components/media/photo-gallery';
import './components/media/play-in-view';
import './components/media/video-controls';
import './components/media/video-embed';
import './components/media/video-gallery';
// Misc
import './components/emergency';


// Global 4 transition
import './components/navigation/transition-sidebar-menu';

